import { useSelector } from 'react-redux'

import {
  makeSelectSegmentAnalyticsMetadata,
  makeSelectUser,
} from '@webapp/core/stores/global'
import { GlobalAnalytics } from './GlobalAnalytics'

export const ConnectedGlobalAnalytics = () => {
  const user = useSelector(makeSelectUser())
  const segmentAnalyticsMetadata = useSelector(
    makeSelectSegmentAnalyticsMetadata()
  )

  const shouldRender =
    user?.id &&
    segmentAnalyticsMetadata?.group &&
    segmentAnalyticsMetadata?.user

  if (!shouldRender) {
    return null
  }

  return (
    <GlobalAnalytics
      user={user}
      segmentAnalyticsMetadata={segmentAnalyticsMetadata}
    />
  )
}
